import React, { useRef, useState } from "react";
import ProgressSteps from "../components/ProgressSteps";
import FormField from "../components/FormField";
import DateField from "../components/DateField";
import SignaturePad from "../components/SignaturePad";
import { createContract } from "../api/contractApi";
import { getStoredProfileSignature } from "../utils/profileSignature";
import { applyProfilePersonalInfo } from "../utils/profilePersonalInfo";
import { getCurrentUser } from "../api/authApi";

const INITIAL_DATA = {
  firstName: "",
  lastName: "",
  fatherName: "",
  idNumber: "",
  nationalCode: "",
  idIssuePlace: "",
  birthDate: "",
  address: "",
  phone: "",
  mobile: "",
  signature: null,
  sellerMobile: "",
};

const STEPS = [{ title: "اطلاعات هویتی" }, { title: "بازبینی و امضا" }];

function BuyerPersonalInfo({ data, onChange }) {
  const handleBirthDateChange = (e) => {
    let value = e.target.value.replace(/[^۰-۹0-9/]/g, "").replace(/\/+/g, "/");
    const digits = value.replace(/\//g, "");
    if (digits.length <= 4) value = digits;
    else if (digits.length <= 6)
      value = digits.slice(0, 4) + "/" + digits.slice(4);
    else
      value =
        digits.slice(0, 4) +
        "/" +
        digits.slice(4, 6) +
        "/" +
        digits.slice(6, 8);
    onChange({ target: { name: "birthDate", value } });
  };

  return (
    <div>
      <h2 className="text-lg font-bold text-navy">اطلاعات هویتی خریدار</h2>
      <p className="mt-1 text-sm text-gray-500">
        اطلاعات شناسایی خود را مطابق کارت ملی و شناسنامه وارد کنید.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          label="نام"
          name="firstName"
          value={data.firstName}
          onChange={onChange}
          placeholder="مثلاً محمد"
          required
        />
        <FormField
          label="نام خانوادگی"
          name="lastName"
          value={data.lastName}
          onChange={onChange}
          placeholder="مثلاً رضایی"
          required
        />
        <FormField
          label="نام پدر"
          name="fatherName"
          value={data.fatherName}
          onChange={onChange}
          placeholder="مثلاً احمد"
          required
        />
        <FormField
          label="شماره شناسنامه"
          name="idNumber"
          value={data.idNumber}
          onChange={onChange}
          placeholder="شماره شناسنامه"
          required
        />
        <FormField
          label="کد ملی"
          name="nationalCode"
          value={data.nationalCode}
          onChange={onChange}
          placeholder="کد ملی ۱۰ رقمی"
          required
        />
        <FormField
          label="محل صدور شناسنامه"
          name="idIssuePlace"
          value={data.idIssuePlace}
          onChange={onChange}
          placeholder="مثلاً اصفهان"
          required
        />
        <DateField
          label="تاریخ تحویل"
          name="birthDate"
          value={data.birthDate}
          onChange={onChange}
          required
        />
        <FormField
          label="تلفن همراه"
          name="mobile"
          type="tel"
          value={data.mobile}
          onChange={onChange}
          placeholder="مثلاً ۰۹۱۲۱۲۳۴۵۶۷"
          required
        />
        <FormField
          label="تلفن ثابت"
          name="phone"
          type="tel"
          value={data.phone}
          onChange={onChange}
          placeholder="مثلاً ۰۲۱۸۸۸۸۸۸۸۸"
        />
        <FormField
          label="آدرس"
          name="address"
          type="textarea"
          value={data.address}
          onChange={onChange}
          placeholder="آدرس کامل محل سکونت"
          full
          required
        />
      </div>
    </div>
  );
}

function BuyerReviewStep({ data, onChange, onSignatureChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">بازبینی و امضای خریدار</h2>
      <p className="mt-1 text-sm text-gray-500">
        اطلاعات خود را بررسی کنید، سپس امضا کرده و شماره فروشنده را وارد نمایید.
      </p>

      {/* خلاصه اطلاعات */}
      <div className="mt-6 rounded-xl border border-sky/30 bg-sky/5 p-4">
        <h3 className="mb-3 text-sm font-bold text-sky-dark">اطلاعات خریدار</h3>
        <div className="grid grid-cols-2 gap-y-2 text-sm">
          <span className="text-gray-500">نام و نام خانوادگی</span>
          <span className="font-medium text-navy">
            {`${data.firstName} ${data.lastName}`.trim() || "—"}
          </span>
          <span className="text-gray-500">کد ملی</span>
          <span className="font-medium text-navy">
            {data.nationalCode || "—"}
          </span>
          <span className="text-gray-500">تلفن همراه</span>
          <span className="font-medium text-navy">{data.mobile || "—"}</span>
        </div>
      </div>

      {/* امضا */}
      <div className="mt-6">
        <label className="mb-1.5 block text-sm font-medium text-navy-light">
          امضای خریدار <span className="text-red-500">*</span>
        </label>
        <SignaturePad value={data.signature} onChange={onSignatureChange} />
      </div>

      {/* شماره موبایل فروشنده */}
      <div className="mt-6 border-t border-gray-100 pt-6">
        <h3 className="mb-1 text-sm font-bold text-navy">
          ارسال قولنامه به فروشنده
        </h3>
        <p className="mb-3 text-xs text-gray-500">
          بعد از ثبت، یک لینک اختصاصی به این شماره پیامک می‌شود تا فروشنده
          اطلاعات و امضای خود را تکمیل کند.
        </p>
        <div className="relative">
          <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-lg">
            📱
          </span>
          <input
            type="tel"
            name="sellerMobile"
            value={data.sellerMobile}
            onChange={onChange}
            placeholder="شماره موبایل فروشنده — مثلاً ۰۹۱۲۱۲۳۴۵۶۷"
            className="w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-4 pr-10 text-sm text-navy placeholder:text-gray-400 outline-none transition focus:border-sky focus:ring-2 focus:ring-sky-light/50"
          />
        </div>
      </div>
    </div>
  );
}

export default function BuyerFirstWizard({ onComplete, onBackToRoles }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState(() => ({
    ...INITIAL_DATA,
    signature: getStoredProfileSignature(),
  }));

  React.useEffect(() => {
    let active = true;

    getCurrentUser()
      .then((user) => {
        if (!active) return;
        setFormData((prev) => applyProfilePersonalInfo({ ...prev }, user));
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, []);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const formRef = useRef(null);

  const isLastStep = currentStep === STEPS.length;
  const isFirstStep = currentStep === 1;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignatureChange = (dataUrl) => {
    setFormData((prev) => ({ ...prev, signature: dataUrl }));
  };

  const handleFinalSubmit = async () => {
    if (!formData.signature) {
      window.alert("لطفاً پیش از ثبت نهایی، امضای خود را وارد کنید.");
      return;
    }
    if (!formData.sellerMobile || formData.sellerMobile.trim().length < 10) {
      window.alert("لطفاً شماره موبایل فروشنده را وارد کنید.");
      return;
    }

    setSubmitting(true);
    setSubmitError("");

    try {
      const payload = {
        createdFor: "buyyer",
        sendRequestFor: formData.sellerMobile,
        buyer: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          fatherName: formData.fatherName,
          idNumber: formData.idNumber,
          nationalCode: formData.nationalCode,
          idIssuePlace: formData.idIssuePlace,
          birthDate: formData.birthDate,
          address: formData.address,
          phone: formData.phone,
          mobile: formData.mobile,
          signature: formData.signature,
        },
        contractNumber: `K24-${Date.now()}`,
        status: "pending_seller",
      };

      const data = await createContract(payload);
      const contractId =
        data?._id ||
        data?.id ||
        data?.data?._id ||
        data?.data?.id ||
        data?.contract?._id;

      if (!contractId) throw new Error("شناسه قولنامه از سرور دریافت نشد.");

      onComplete({ ...formData, contractId });
    } catch (err) {
      setSubmitError(err.message || "خطا در ارتباط با سرور. دوباره تلاش کنید.");
    } finally {
      setSubmitting(false);
    }
  };

  const goNext = () => {
    if (formRef.current && !formRef.current.reportValidity()) return;
    if (isLastStep) {
      handleFinalSubmit();
      return;
    }
    setCurrentStep((s) => s + 1);
  };

  const goBack = () => {
    if (isFirstStep) {
      onBackToRoles();
      return;
    }
    setCurrentStep((s) => s - 1);
  };

  return (
    <div className="min-h-screen bg-surface px-4 py-6 sm:py-10">
      <div className="mx-auto w-full max-w-3xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-lg text-white">
            🧾
          </div>
          <div>
            <h1 className="text-base font-extrabold text-navy sm:text-lg">
              قولنامه هوشمند — خریدار
            </h1>
            <p className="text-xs text-gray-500">قرارداد ۲۴</p>
          </div>
        </div>

        <div className="mb-6 rounded-2xl bg-white p-4 shadow-card sm:p-5">
          <ProgressSteps steps={STEPS} currentStep={currentStep} />
        </div>

        <form
          ref={formRef}
          onSubmit={(e) => e.preventDefault()}
          className="step-enter rounded-2xl bg-white p-5 shadow-card sm:p-8"
        >
          {currentStep === 1 && (
            <BuyerPersonalInfo data={formData} onChange={handleChange} />
          )}
          {currentStep === 2 && (
            <BuyerReviewStep
              data={formData}
              onChange={handleChange}
              onSignatureChange={handleSignatureChange}
            />
          )}

          {submitError && (
            <p className="mt-4 rounded-lg bg-red-50 px-4 py-2.5 text-sm text-red-600">
              ⚠️ {submitError}
            </p>
          )}
        </form>

        <div className="mt-6 flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={goBack}
            disabled={submitting}
            className="rounded-xl border border-gray-200 bg-white px-6 py-2.5 text-sm font-bold text-navy transition hover:border-sky-light disabled:opacity-50"
          >
            {isFirstStep ? "بازگشت به انتخاب نقش" : "مرحله قبل"}
          </button>
          <button
            type="button"
            onClick={goNext}
            disabled={submitting}
            className="flex items-center gap-2 rounded-xl bg-sky px-8 py-2.5 text-sm font-bold text-white shadow-card transition hover:bg-sky-dark disabled:opacity-60"
          >
            {submitting && (
              <svg
                className="h-4 w-4 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                />
              </svg>
            )}
            {submitting
              ? "در حال ثبت..."
              : isLastStep
                ? "ثبت و ارسال به فروشنده"
                : "مرحله بعد"}
          </button>
        </div>
      </div>
    </div>
  );
}
